import { useEffect, useState } from "react"
import { useRecoilState } from "recoil"

import {
  filtersValuesState,
  recordCountValuesState,
  recordCountNumber,
  FinalWhereClsAM,
  Spiner,
} from "../../atoms/audienceCatBuilderAtom"
import { dealerInfo } from "../../atoms/DealerAtom"
import arrowup from "../../assets/images/arrowup.png"
import { createSQLYesSentence } from "./utils"
import { postApiHelper } from "../../util/apiHelpers"

const IntCampingHiking = ({ setInt }) => {
  const [campingHiking, setCampingHiking] = useState([
    { name: "Yes", id: "0", selected: false },
  ])
  const [filtersValues, setFiltersValues] = useRecoilState(filtersValuesState)
  const [recordRequest, setRecordRequest] = useRecoilState(
    recordCountValuesState
  )
  const setSpiner = useRecoilState(Spiner)[1]
  const [AdWhereClsAM, setAdWhereClsAM] = useRecoilState(FinalWhereClsAM)
  const setRecordCount = useRecoilState(recordCountNumber)[1]
  const dealerInfoValue = useRecoilState(dealerInfo)[0]

  const campingHikingPersistency = () => {
    const campingHikingList = [{ name: "Yes", id: "0", selected: false }]
    for (let i = 0; i < campingHikingList.length; i++) {
      if (filtersValues.campingHiking) {
        filtersValues.campingHiking &&
          (campingHikingList[i] = { ...campingHikingList[i], selected: true })
      }
    }
  }

  useEffect(() => {
    campingHikingPersistency()
  }, [])

  const changeInput = (event) => {
    const campingHikingAux = [...campingHiking]
    campingHikingAux[
      event.target.id.substring(0, event.target.id.length - 13)
    ].selected = event.target.checked
    setCampingHiking(campingHikingAux)
  }

  const handleCampingHikingChange = () => {
    if (campingHiking[0].selected) {
      sendRequestCount(`'Y'`)
      setFiltersValues({ ...filtersValues, campingHiking: true })
      setRecordRequest({ ...recordRequest, campingHiking: true })
    } else {
      sendRequestCount("")
      setFiltersValues({ ...filtersValues, campingHiking: false })
    }
    setInt({
      outdoorsmen: false,
      hunting: false,
      fishing: false,
      campingHiking: true,
      huntingShooting: false,
      motorcycling: false,
    })
  }

  const sendRequestCount = (recordRequestBody) => {
    setSpiner(true)
    const WhereClsAM = createSQLYesSentence(
      recordRequestBody,
      "C.Camping_Hiking",
      AdWhereClsAM
    )
    setAdWhereClsAM({ sql: WhereClsAM })
    postApiHelper(`BigQuery/getConsumersCountFromBigQuery`, {
      sql: WhereClsAM,
      roofTopID: dealerInfoValue.rooftopID,
      sqlService: filtersValues.excludeService
        ? `${filtersValues.excludeService}`
        : "",
      sqlSales: filtersValues.excludeSales
        ? `${filtersValues.excludeSales}`
        : "",
    }).then((res) => {
      const resBigQuery = res.data[0]
      const resBigQueryExclude = res.data[1]?.numpid
      if (filtersValues.excludeSales && filtersValues.excludeService) {
        setRecordCount({
          value: resBigQuery.numpid,
          amountExcludeService: resBigQueryExclude,
          amountExcludeSales: res.data[2]?.numpid,
        })
      } else {
        setRecordCount({
          value: resBigQuery.numpid,
          amountExcludeSales: filtersValues.excludeSales
            ? resBigQueryExclude
            : null,
          amountExcludeService: filtersValues.excludeService
            ? resBigQueryExclude
            : null,
        })
      }
      setSpiner(false)
    })
  }

  useEffect(() => {
    filtersValues.campingHiking &&
      setCampingHiking([{ name: "Yes", id: "0", selected: true }])
  }, [filtersValues.campingHiking])

  return (
    <div className="flex flex-col items-center">
      <fieldset className="h-auto">
        <legend className="sr-only">Camping Hiking</legend>
        <h1 className="font-bold text-[#586283] text-[20px] mb-4">
          Camping Hiking
        </h1>
        {campingHiking.map((item) => (
          <div className="flex items-center justify-center mb-4" key={item.id}>
            <input
              id={`${item.id}campinghiking`}
              checked={item.selected}
              onChange={(event) => changeInput(event)}
              aria-describedby={`checkbox-${item.id}campinghiking`}
              type="checkbox"
              className="w-4 h-4 text-[#298FC2] bg-[#298fc217] rounded border-gray-300 focus:ring-[#298FC2] focus:ring-2"
            />
            <label
              htmlFor={`${item.id}campinghiking`}
              className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              {item.name}
            </label>
          </div>
        ))}
      </fieldset>
      <button
        onClick={handleCampingHikingChange}
        type="button"
        className="flex flex-row justify-between text-white bg-[#298FC2] focus:ring-4 font-bold rounded-lg text-sm px-5 py-2.5 text-center mb-2"
      >
        Submit
        <img className="py-[2px] px-2" src={arrowup} alt="arrow" />
      </button>
    </div>
  )
}

export default IntCampingHiking
